export default __webpack_public_path__ + "static/img8-bffb99347d6aca93fa04db86e49fed73.png";